import type { PaidPlanTier } from '@/types/billing-plan';

/**
 * Existing Team-plan installations created before this UTC instant keep coding-agent access.
 */
export const CODING_AGENTS_GRANDFATHERED_TEAM_CUTOFF = new Date('2026-04-29T00:00:00.000Z');

export const CODING_AGENTS_AVAILABILITY_MESSAGE =
  'Fix with cubic is available during trial and on Pro and Max.';

export const CODING_AGENTS_UPGRADE_MESSAGE = `${CODING_AGENTS_AVAILABILITY_MESSAGE} Upgrade your plan to use this feature.`;

export function isCodingAgentsEntitled({
  installationCreatedAt,
  isTrialing,
  planTier,
}: {
  installationCreatedAt: Date | string | null;
  isTrialing: boolean;
  planTier: PaidPlanTier | null;
}): boolean {
  if (isTrialing) {
    return true;
  }

  if (planTier === 'pro') {
    return true;
  }

  if (planTier !== 'team' || !installationCreatedAt) {
    return false;
  }

  return new Date(installationCreatedAt) < CODING_AGENTS_GRANDFATHERED_TEAM_CUTOFF;
}
